import { buildBlogCollectionRenderField } from '@/components/blocks/collection/field-renderers/blog';
import { buildCaseResultCollectionRenderField } from '@/components/blocks/collection/field-renderers/case-result';
import { buildReviewCollectionRenderField } from '@/components/blocks/collection/field-renderers/review';
import type { CollectionCardConfig, CollectionItem } from '@/lib/blocks/collection/blocks';
import type { PageBlock } from '@/types/block';
import type { RenderField } from '../collection/types';

export function buildRenderFieldForItem(
  block: PageBlock,
  item: CollectionItem,
  cardConfig: CollectionCardConfig,
): RenderField | undefined {
  if (block.blockType === 'blog_widget') {
    return buildBlogCollectionRenderField({ item, cardConfig, variant: 'widget' });
  }
  if (block.blockType === 'case_result_widget') {
    return buildCaseResultCollectionRenderField({ item, cardConfig, variant: 'widget' });
  }
  if (block.blockType === 'review_widget') {
    return buildReviewCollectionRenderField({ item, cardConfig });
  }
  return undefined;
}
